import React from 'react'
import { ReactComponent as ViewIcon } from '@assets/images/Icons/View.svg'
import { ReactComponent as EditIcon } from '@assets/images/Icons/Edit.svg'
import { ReactComponent as DeleteIcon } from '@assets/images/Icons/Delete1.svg'
import { ReactComponent as DollarIcon } from '@assets/images/Icons/Dollar.svg'
import { ReactComponent as AdjustmentIcon } from '@assets/images/Icons/Adjustment.svg'
import { ReactComponent as DocumentIcon } from '@assets/images/Icons/Document.svg'
import { ReactComponent as Document2Icon } from '@assets/images/Icons/Document2.svg'
import { ReactComponent as CallIcon } from '@assets/images/Icons/Call.svg'
import { ReactComponent as SendInAdvance2Icon } from '@assets/images/Icons/Send_in_advance_2.svg'
import { ReactComponent as MessageIcon } from '@assets/images/Icons/Message.svg'
import { ReactComponent as CopyIcon } from '@assets/images/Icons/Copy.svg'
import { ReactComponent as Print2Icon } from '@assets/images/Icons/Print2.svg'
import { ReactComponent as PinIcon } from '@assets/images/Icons/Pin.svg'

type SvgIconComponent = React.FC<React.SVGProps<SVGSVGElement>>

const DsIcon: React.FC<{ Icon: SvgIconComponent }> = ({ Icon }) => (
  <Icon className="ds-action-button__svg" aria-hidden="true" />
)

/** Design-system Icons used by ActionButtons (from `assets/images/Icons`). */
export const ActionButtonIcons = {
  view: () => <DsIcon Icon={ViewIcon} />,
  edit: () => <DsIcon Icon={EditIcon} />,
  delete: () => <DsIcon Icon={DeleteIcon} />,
  payment: () => <DsIcon Icon={DollarIcon} />,
  refund: () => <DsIcon Icon={AdjustmentIcon} />,
  document: () => <DsIcon Icon={Document2Icon} />,
  viewNotes: () => <DsIcon Icon={DocumentIcon} />,
  phone: () => <DsIcon Icon={CallIcon} />,
  mail: () => <DsIcon Icon={SendInAdvance2Icon} />,
  message: () => <DsIcon Icon={MessageIcon} />,
  duplicate: () => <DsIcon Icon={CopyIcon} />,
  print: () => <DsIcon Icon={Print2Icon} />,
  pin: () => <DsIcon Icon={PinIcon} />,
} as const
